export const NUMBER_OF_BRANDS_PER_PAGE = 15
